import { Component, OnInit, Optional, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { environment } from '../../../../environments/environment';
import { UtilService } from '../../../util/util.service';
import { HttpHeaders } from '@angular/common/http';
import { ApiService } from 'src/app/common/services/api.service';
import { DateService } from 'src/app/common/services/date.service';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { CANCEL, SUCCESS_JSON } from 'src/defaultImages.js';
@Component({
  selector: 'app-clockin-out',
  templateUrl: './clockin-out.component.html',
  styleUrls: ['./clockin-out.component.css'],
})
export class ClockinOutComponenet implements OnInit {
  images = {
    CANCEL: CANCEL,
    SUCCESS_JSON: SUCCESS_JSON
  };
  currState = 'Clock-In';
  user_id = '';
  bearerToken = '';
  isSuccess = false;
  user_name = 'user';
  successIcon =
    environment.aws_s3_bucket_url + '/partner-app/assets/clockin-success.png';
  options: AnimationOptions = {
    path: this.images.SUCCESS_JSON,
  };
  constructor(
    public dialogRef: MatDialogRef<any>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public utilService: UtilService,
    private apiService: ApiService,
    private _dateService: DateService
  ) {}

  ngOnInit() {
    this.user_id = this.data.user_id;
    this.bearerToken = this.data.bearerToken;
    if (this.data.status == 'clockin') {
      this.currState = 'Clock-In';
    } else {
      this.currState = 'Clock-Out';
    }
    this.user_name = this.data.username;
  }
  cancel_clicked() {
    this.dialogRef.close({ data: 'closed' });
  }

  markAttendance() {
    let httpOptions: { headers; observe } = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + this.bearerToken,
      }),
      observe: 'response',
    };
    const payload = {
      restaurant_id: localStorage.getItem('restaurant_id'),
      user_id: this.user_id,
    };
    this.apiService.markAttendance(payload, httpOptions).subscribe(
      (response: any) => {
        if (response.body.statusCode == 201) {
          this.isSuccess = true;
          setTimeout(() => {
            this.cancel_clicked();
          }, 3000);
        } else {
        }
      },
      (error) => {}
    );
  }
  animationCreated(animationItem: AnimationItem): void {}

  getCurremtTimein12(){
    return this._dateService.getCurremtTimein12();
  }

  getCurrentAMPM(){
    return this._dateService.getCurrentAMPM();
  }
  getCurrentDate2(){
    return this._dateService.getCurrentDate2();
  }
}
